import { useParams, useNavigate } from "react-router-dom";

import {
  Box,
  Container,
  Paper,
  Typography,
  Chip,
  Stack,
  IconButton,
  Divider,
  Button,
} from "@mui/material";

import {
  CalendarMonthOutlined,
  ArrowBackRounded,
  ShareOutlined,
} from "@mui/icons-material";


import { useNoticiaTitulo } from "../../hooks/useNoticias";
import { formatearFecha } from "../../utils/FormatoFecha";

export const SubNoticia = () => {

    const { titulo } = useParams();
    const backendURL = process.env.REACT_APP_BACKEND_URL;
    const navigate = useNavigate();

    const {
        noticia,
        loading,
        error,
    } = useNoticiaTitulo(titulo);

   

     if (loading) {
        return (
            <Box
                sx={{
                    minHeight: "100vh",
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                }}
            >
                <Typography>
                    Cargando noticia...
                </Typography>
            </Box>
        );
    }


    // ❌ Si no encontró la noticia
    if (error || !noticia) {
        return (
            <Box
                sx={{
                    minHeight: "100vh",
                    display: "flex",
                    flexDirection: "column",
                    justifyContent: "center",
                    alignItems: "center",
                    gap: 2,
                }}
            >
                <Typography variant="h5">
                    Noticia no encontrada
                </Typography>

                <Button
                    onClick={() => navigate("/noticias")}
                >
                    Volver a noticias
                </Button>
            </Box>
        );
    }

  return (
    <Box
      sx={{
        minHeight: "100vh",
        bgcolor: "#f6f8fc",
        py: {
          xs: 4,
          sm: 6,
          md: 8,
        },
      }}
    >

      <Container
        maxWidth="lg"
      >

        {/* ================================================= */}
        {/* BOTÓN VOLVER */}
        {/* ================================================= */}

        <Button
          startIcon={<ArrowBackRounded />}
          onClick={() => navigate("/noticias")}
          sx={{
            mb: 4,
            color: "#484a75",
            fontWeight: 700,
            textTransform: "none",
            borderRadius: "12px",
            px: 2,
            py: 1,

            "&:hover": {
              bgcolor: "#e9ebf5",
            },
          }}
        >
          Volver a noticias
        </Button>


        {/* ================================================= */}
        {/* CONTENIDO PRINCIPAL */}
        {/* ================================================= */}

        <Paper
          elevation={0}
          sx={{
            overflow: "hidden",
            borderRadius: {
              xs: "20px",
              sm: "28px",
              md: "32px",
            },

            border: "1px solid #e8ebf2",

            boxShadow:
              "0 20px 60px rgba(24,38,70,.08)",
          }}
        >

          {/* ================================================= */}
          {/* IMAGEN DESTACADA */}
          {/* ================================================= */}

          <Box
            sx={{
              position: "relative",

              height: {
                xs: 240,
                sm: 340,
                md: 460,
              },

              overflow: "hidden",
            }}
          >

           <Box
                component="img"
                src={`${backendURL}/${noticia.img2}`}
                alt={noticia.titulo}
                sx={{
                    width: "100%",
                    height: "100%",
                    objectFit: "cover",
                    objectPosition: "center",
                }}
            />
 
            {/* Overlay */}

            <Box
              sx={{
                position: "absolute",
                inset: 0,

                background:
                  "linear-gradient(180deg, rgba(20,27,77,.05) 25%, rgba(20,27,77,.85) 100%)",
              }}
            />

            {/* Categoría */}

            <Chip
              label={noticia.tipo}
              sx={{
                position: "absolute",

                top: {
                  xs: 18,
                  sm: 25,
                },

                left: {
                  xs: 18,
                  sm: 30,
                },

                bgcolor: "#c12559",
                color: "#fff",

                fontWeight: 700,

                borderRadius: "30px",

                px: 1,
              }}
            />

            {/* Título sobre imagen */}

            <Box
              sx={{
                position: "absolute",

                bottom: {
                  xs: 20,
                  sm: 30,
                  md: 40,
                },

                left: {
                  xs: 20,
                  sm: 35,
                  md: 50,
                },

                right: {
                  xs: 20,
                  sm: 35,
                  md: 50,
                },
              }}
            >

              <Typography
                sx={{
                  color: "#fff",

                  fontWeight: 800,

                  lineHeight: 1.1,

                  fontSize: {
                    xs: "1.6rem",
                    sm: "2.2rem",
                    md: "3rem",
                  },

                  maxWidth: 850,
                }}
              >
                {noticia.titulo}
              </Typography>

            </Box>

          </Box>


          {/* ================================================= */}
          {/* INFORMACIÓN DE LA NOTICIA */}
          {/* ================================================= */}

          <Box
            sx={{
              px: {
                xs: 3,
                sm: 5,
                md: 7,
              },

              py: {
                xs: 3,
                sm: 4,
                md: 5,
              },
             
            }}
          >

            {/* Fecha + compartir */}

            <Stack
              direction="row"
              justifyContent="space-between"
              alignItems="center"
              spacing={2}
            >

              <Stack
                direction="row"
                spacing={1}
                sx={{
                  display:'flex', alignItems:'center', justifyContent:'center'
                }}
              >
                
                <CalendarMonthOutlined
                  sx={{
                    color: "#484a75",
                    fontSize: 22,
                  }}
                />

                <Typography
                  sx={{
                    color: "#687083",

                    fontSize: {
                      xs: ".85rem",
                      sm: ".95rem",
                    },
                  }}
                >
                 {formatearFecha(noticia.fecha)}
                </Typography>

              </Stack>


              <IconButton
                sx={{
                  color: "#484a75",

                  bgcolor: "#f1f2f8",

                  "&:hover": {
                    bgcolor: "#e5e7f2",
                  },
                }}
              >
                <ShareOutlined />
              </IconButton>

            </Stack>


            <Divider
              sx={{
                my: 3,
              }}
            />


            {/* ================================================= */}
            {/* CONTENIDO */}
            {/* ================================================= */}

            <Box
              sx={{
                maxWidth: 850,
                mx: "auto",
              }}
            >



             <Box
    sx={{
        maxWidth: 850,
        mx: "auto",
    }}
>
    <Typography
        sx={{
            color: "#484a75",
            fontWeight: 700,
            fontSize: {
                xs: "1.2rem",
                sm: "1.4rem",
            },
            mb: 3,
        }}
    >
        Información de la noticia
    </Typography>

    <Box
        className="noticia-contenido"
        dangerouslySetInnerHTML={{
            __html: noticia.contenido || "",
        }}
        sx={{
            color: "#566070",

            fontSize: {
                xs: ".95rem",
                sm: "1rem",
                md: "1.05rem",
            },

            lineHeight: 1.8,

            "& p": {
                margin: "0 0 20px 0",
            },

            "& h1": {
                color: "#12213F",
                fontWeight: 800,
                marginTop: "30px",
                marginBottom: "15px",
            },

            "& h2": {
                color: "#484a75",
                fontWeight: 800,
                marginTop: "30px",
                marginBottom: "15px",
            },

            "& h3": {
                color: "#484a75",
                fontWeight: 700,
                marginTop: "25px",
                marginBottom: "12px",
            },

            "& strong": {
                fontWeight: 700,
                color: "#12213F",
            },

            "& em": {
                fontStyle: "italic",
            },

            "& ul": {
                paddingLeft: "25px",
                marginBottom: "20px",
            },

            "& ol": {
                paddingLeft: "25px",
                marginBottom: "20px",
            },

            "& li": {
                marginBottom: "8px",
            },

            "& a": {
                color: "#C62828",
                textDecoration: "underline",
            },

            "& blockquote": {
                borderLeft: "4px solid #C62828",
                paddingLeft: "20px",
                marginLeft: 0,
                color: "#687083",
                fontStyle: "italic",
            },

            "& img": {
                maxWidth: "100%",
                height: "auto",
                display: "block",
                margin: "25px auto",
                borderRadius: "12px",
            },
        }}
    />
</Box>

            </Box>

          </Box>

        </Paper>


        {/* ================================================= */}
        {/* PIE */}
        {/* ================================================= */}

        <Box
          sx={{
            mt: 4,

            display: "flex",
            justifyContent: "center",
          }}
        >

          <Button
            startIcon={<ArrowBackRounded />}
            onClick={() => navigate("/noticias")}
            sx={{
              color: "#484a75",
              fontWeight: 700,
              textTransform: "none",

              borderRadius: "14px",

              px: 3,
              py: 1.3,

              border: "1px solid #dfe2ed",

              "&:hover": {
                bgcolor: "#484a75",
                color: "#fff",
              },
            }}
          >
            Volver a todas las noticias
          </Button>

        </Box>

      </Container>

    </Box>
  );
};